/**
 * 获取请求相关的 headers 信息
 * @returns headers 信息对象
 */
export async function getRequestHeaders() {
  const { headers } = await import("next/headers")
  const headersList = await headers()

  return {
    userAgent: headersList.get("user-agent") || "",
    pathname: headersList.get("x-pathname") || headersList.get("x-invoke-path") || "/",
    headersList,
  }
}
